import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  selectCustomerAppointmentsByLeadId,
  selectCustomerAppointmentsByLeadIdLoading,
} from 'features/myAppointments/MyAppointmentsSlice';
import { formatDateTime } from 'utils/dateUtils';

import {
  Card,
  CardHeader,
  CardTitle,
  Label,
  LoadingText,
  Row,
  SectionTitle,
  StatusBadge,
  Value,
  Wrapper,
} from './CustomerAppointments.styles';

const CustomerAppointments = () => {
  const navigate = useNavigate();
  const appointments = useSelector(selectCustomerAppointmentsByLeadId);
  const loading = useSelector(selectCustomerAppointmentsByLeadIdLoading);

  if (loading) {
    return (
      <Wrapper>
        <SectionTitle>Appointments</SectionTitle>
        <LoadingText>Loading appointments...</LoadingText>
      </Wrapper>
    );
  }

  if (!appointments || appointments.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <SectionTitle>Appointments</SectionTitle>
      {appointments.map((elm) => {
        const assignees = (elm.userToAppointments || [])
          .filter((u) => u.type === 'Assignee')
          .map((u) => `${u.user?.name || ''} ${u.user?.surname || ''}`.trim());

        const handleClick = () => navigate(`/my-single-appointments/${elm.uuid}`);

        return (
          <Card key={elm.uuid} onClick={handleClick}>
            <CardHeader>
              <CardTitle>{formatDateTime(elm.date)}</CardTitle>
              <StatusBadge status={elm.status}>{elm.status}</StatusBadge>
            </CardHeader>

            <Row>
              <Label>ID:</Label>
              <Value>{elm.id}</Value>
            </Row>

            {elm.location && (
              <Row>
                <Label>Location:</Label>
                <Value>{elm.location}</Value>
              </Row>
            )}

            <Row>
              <Label>Description:</Label>
              <Value>{elm.description}</Value>
            </Row>

            <Row>
              <Label>Service:</Label>
              <Value>{elm.service}</Value>
            </Row>

            <Row>
              <Label>Sub-service:</Label>
              <Value>{elm.subService?.name}</Value>
            </Row>

            <Row>
              <Label>Frequency:</Label>
              <Value>{elm.frequency}</Value>
            </Row>

            {elm.newOffers && elm.newOffers !== 'undefined' && (
              <Row>
                <Label>Offer:</Label>
                <Value>{elm.newOffers}</Value>
              </Row>
            )}
            <Row>
              <Label>Phone Call:</Label>
              <Value>{elm.communicationMethod?.phoneCall}</Value>
            </Row>

            {assignees.length > 0 && (
              <Row>
                <Label>Assignee:</Label>
                {assignees.map((name, i) => (
                  <Value key={i}>{name}</Value>
                ))}
              </Row>
            )}
            <Row>
              <Label>Created by:</Label>
              <Value>
                {elm.createdBy?.name} {elm.createdBy?.surname}
              </Value>
            </Row>
          </Card>
        );
      })}
    </Wrapper>
  );
};

export default CustomerAppointments;
